import { useSelector } from 'react-redux'

import type { ParentCategory } from '@library/menu-service'

import { getParentCategories } from 'selectors/menu-parentcategories/getParentCategories'

export const useParentCategories = (): ParentCategory[] => {
  return useSelector(getParentCategories)
}
